<section class="view-content">
  <div class="holder">
    <b>
      {{ ("questionnaire." + questionnaireType) | translate }} ({{questionnaire.length}})
    </b>
  </div>

  <form [formGroup]="questionaireForm">
    <div class="question-container" *ngFor="let question of questionnaire">
      <div class="question-title">
        {{ question?.questionText }}
      </div>
      
      <eyrus-questionnaire-question-text 
        [readOnly]="readOnly"
        [formControlName]="question.questionField"
        [isNumber]="question?.questionTypeId === 2"
        *ngIf="question?.questionTypeId === 2 || question?.questionTypeId === 4">
      </eyrus-questionnaire-question-text>

      <eyrus-questionnaire-question-dropdown
        [formControlName]="question.questionField"
        [options]="question?.answerOptions"
        [label]="'availableAnswerText'"
        [value]="'availableAnswerText'"
        *ngIf="question?.questionTypeId === 1">
      </eyrus-questionnaire-question-dropdown>

      <eyrus-questionnaire-question-radio
        [readOnly]="readOnly"
        [formControlName]="question.questionField"
        [options]="question?.answerOptions"
        [label]="'availableAnswerText'"
        [value]="'availableAnswerText'"
        *ngIf="question?.questionTypeId === 3">
      </eyrus-questionnaire-question-radio>
    </div>
  </form>

  <div class="buttons-row text-center">
    <button mat-raised-button class="md  m-r-md"
      color="primary"
      (click)="goBack()">
      <span class="capitalize"> {{ "common.back" | translate }}  </span>
    </button>
  </div>
</section>